<div class="back-header">
    <!-- Back Button -->
    <div class="back-icon" (click)="BackTrainingVideo()">
        <i class="dx-icon dx-icon-chevronleft"></i>
    </div>
    <!-- Title -->
    <div class="back-text">{{DetailsFormTitle}}</div>
</div>
<div class="form-wrapper">
    <div class="input-grid">

        <div class="separate-input-field">
            <label for="Link" class="lable">Link</label>
            <dx-text-box id="Link" name="Link" [(ngModel)]="Entity.p.link" stylingMode="outlined"
                placeholder="Enter Link" [width]="'100%'" class="inputfield">
            </dx-text-box>
        </div>

        <div class="separate-input-field">
            <label for="Description" class="lable">Description</label>
            <dx-text-box id="Description" name="Description" [(ngModel)]="Entity.p.description_en" stylingMode="outlined"
                placeholder="Enter Description" [width]="'100%'" class="inputfield">
            </dx-text-box>
        </div>
        <div class="separate-input-field">
            <label for="Description" class="lable">Description in देवनागरी</label>
            <dx-text-box id="Description" name="Description" [(ngModel)]="Entity.p.description_mr" stylingMode="outlined"
                placeholder="Enter Description" [width]="'100%'" class="inputfield">
            </dx-text-box>
        </div>

        <!-- READONLY OVERLAY -->
        <div *ngIf="IsReadOnlyMode" class="readonly-overlay"></div>
    </div>
</div>
<div class="button-section" [align]="'center'" style="margin-top: 5rem">
    <app-cancelbutton text="Cancel" (click)="BackTrainingVideo()"></app-cancelbutton>
    <dx-button [elementAttr]="{ class: 'save-button' }" (click)="SaveTrainingVideo()" [disabled]="isSaveDisabled"
        [text]="IsNewEntity ?  'Save' : 'Update'" type="default" stylingMode="contained" *ngIf="CanAddOrEdit">
    </dx-button>
</div>